define('presentation/common/callDetails/common/callDetailsBuilder',[
    'common/converters/phoneNumberFormatter',
    'presentation/common/callDetails/presentationObjects/callDetailsPresentationObject' ,
    'presentation/common/callDetails/presentationObjects/firstCallDetailStepPresentationObject',
    'presentation/common/callDetails/presentationObjects/callDetailStepPresentationObject',
    'presentation/common/callDetails/presentationObjects/callDetailsLocationPresentationObject',
    'presentation/common/callDetails/presentationObjects/callDetailsVoicemailPresentationObject',
    'presentation/common/callDetails/presentationObjects/callDetailsRecordingPresentationObject',
    'presentation/common/callDetails/presentationObjects/callDetailsReceptionistMessagePresentationObject'
],  function() {
    return function() {
        let self = this;

        const PhoneNumberFormatterConstructor = require('common/converters/phoneNumberFormatter');
        const _phoneNumberFormatter = new PhoneNumberFormatterConstructor();

        const CallDetailsPresentationObject = require('presentation/common/callDetails/presentationObjects/callDetailsPresentationObject');
        const FirstCallDetailStepPresentationObject = require('presentation/common/callDetails/presentationObjects/firstCallDetailStepPresentationObject');
        const CallDetailStepPresentationObject = require('presentation/common/callDetails/presentationObjects/callDetailStepPresentationObject');
        const CallDetailLocationPresentationObject = require('presentation/common/callDetails/presentationObjects/callDetailsLocationPresentationObject');
        const CallDetailsVoicemailPresentationObject = require('presentation/common/callDetails/presentationObjects/callDetailsVoicemailPresentationObject');
        const CallDetailsRecordingPresentationObject = require('presentation/common/callDetails/presentationObjects/callDetailsRecordingPresentationObject');
        const CallDetailsReceptionistMessagePresentationObject = require('presentation/common/callDetails/presentationObjects/callDetailsReceptionistMessagePresentationObject');

        const _formatCallDetailsForDisplay = (callHistoryId, callDetails) => {
            const firstCallDetailStep = new FirstCallDetailStepPresentationObject();
            firstCallDetailStep.callDateTime = callDetails.firstCallDetailStep.callDateTime;
            firstCallDetailStep.hasCallRecording = callDetails.firstCallDetailStep.hasCallRecording;
            firstCallDetailStep.hasVoicemail = callDetails.firstCallDetailStep.hasVoicemail;
            firstCallDetailStep.otherPartyObjectId = callDetails.firstCallDetailStep.otherPartyObjectId;
            firstCallDetailStep.otherPartyPhoneNumber = callDetails.firstCallDetailStep.otherPartyPhoneNumber;
            firstCallDetailStep.otherPartyType = callDetails.firstCallDetailStep.otherPartyType;
            firstCallDetailStep.otherPartyLocation = callDetails.firstCallDetailStep.otherPartyLocation;
            firstCallDetailStep.callDurationInSeconds = callDetails.firstCallDetailStep.callDurationInSeconds;
            firstCallDetailStep.disposition = callDetails.firstCallDetailStep.disposition;
            firstCallDetailStep.isInbound = callDetails.firstCallDetailStep.isInbound;
            firstCallDetailStep.humanDetectionFailed = callDetails.firstCallDetailStep.humanDetectionFailed;

            const callDetailSteps = callDetails.callDetailSteps.map((step) => {
                const callDetailStep = new CallDetailStepPresentationObject();
                callDetailStep.dateTimeStarted = step.dateTimeStarted;
                callDetailStep.lastStep = step.lastStep;
                callDetailStep.type = step.type;
                callDetailStep.phoneNumber = step.phoneNumber;
                callDetailStep.otherPartyPhoneNumber = step.otherPartyPhoneNumber;
                callDetailStep.otherPartyLocation = step.otherPartyLocation;
                callDetailStep.accountVoicePromptId = step.accountVoicePromptId;
                callDetailStep.name = step.name;
                callDetailStep.metadata = step.metadata;
                callDetailStep.audioUrl = step.audioUrl;
                callDetailStep.durationInSeconds = step.durationInSeconds;
                callDetailStep.location = step.location;
                callDetailStep.systemAudioClipId = step.systemAudioClipId;
                callDetailStep.phoneConnectorId = step.phoneConnectorId;
                callDetailStep.phoneNumberName = step.phoneNumberName;
                callDetailStep.userId = step.userId;
                callDetailStep.exitConditionText = step.exitConditionText;
                callDetailStep.groupId = step.groupId;
                callDetailStep.groupName = step.groupName;
                callDetailStep.forwardingNumberId = step.forwardingNumberId;
                callDetailStep.forwardingNumberName = step.forwardingNumberName;
                callDetailStep.autoAttendantId = step.autoAttendantId;
                callDetailStep.autoAttendantName = step.autoAttendantName;
                callDetailStep.navigationNames = step.navigationNames;
                callDetailStep.voicemailBoxId = step.voicemailBoxId;
                callDetailStep.liveReceptionistScriptId = step.liveReceptionistScriptId;
                return callDetailStep;
            });

            const callerLocation = new CallDetailLocationPresentationObject();
            callerLocation.cityState = _phoneNumberFormatter.cleanupLocation(callDetails.callerLocation.cityState);
            callerLocation.latitude = callDetails.callerLocation.latitude;
            callerLocation.longitude = callDetails.callerLocation.longitude;
            callerLocation.isExternal = callDetails.callerLocation.isExternal;
            callerLocation.phoneNumber = callDetails.callerLocation.phoneNumber;

            const calleeLocation = new CallDetailLocationPresentationObject();
            calleeLocation.cityState = _phoneNumberFormatter.cleanupLocation(callDetails.calleeLocation.cityState);
            calleeLocation.latitude = callDetails.calleeLocation.latitude;
            calleeLocation.longitude = callDetails.calleeLocation.longitude;
            calleeLocation.isExternal = callDetails.calleeLocation.isExternal;
            calleeLocation.phoneNumber = callDetails.calleeLocation.phoneNumber;

            const voicemail = new CallDetailsVoicemailPresentationObject();
            voicemail.status(callDetails.voicemail.status);
            voicemail.voicemailMessageId = callDetails.voicemail.voicemailMessageId;
            voicemail.voicemailMessageStatus = callDetails.voicemail.voicemailMessageStatus;
            voicemail.voicemailIsDeleted = callDetails.voicemail.voicemailIsDeleted;
            voicemail.voicemailDeletedDateTime = callDetails.voicemail.voicemailDeletedDateTime;
            voicemail.voicemailAudioUrl = callDetails.voicemail.voicemailAudioUrl;
            voicemail.durationInSeconds = callDetails.voicemail.durationInSeconds;
            voicemail.canListenToVoicemail = callDetails.voicemail.canListenToVoicemail;
            voicemail.subscriberIds(callDetails.voicemail.subscriberIds);
            voicemail.isDeleted(callDetails.voicemail.voicemailIsDeleted);

            const recording = new CallDetailsRecordingPresentationObject();
            recording.status(callDetails.recording.status);
            recording.recordingMessageId = callDetails.recording.recordingMessageId;
            recording.recordingMessageStatus = callDetails.recording.recordingMessageStatus;
            recording.recordingIsDeleted = callDetails.recording.recordingIsDeleted;
            recording.recordingDeletedDateTime = callDetails.recording.recordingDeletedDateTime;
            recording.recordingAudioUrl = callDetails.recording.recordingAudioUrl;
            recording.durationInSeconds = callDetails.recording.durationInSeconds;
            recording.canListenToRecording = callDetails.recording.canListenToRecording;
            recording.subscriberIds(callDetails.recording.subscriberIds);
            recording.isDeleted(callDetails.recording.recordingIsDeleted);

            const receptionistMessage = new CallDetailsReceptionistMessagePresentationObject();
            if (callDetails.receptionistMessage) {
                receptionistMessage.receptionistMessageId = callDetails.receptionistMessage.receptionistMessageId;
                receptionistMessage.scriptName = callDetails.receptionistMessage.scriptName;
                receptionistMessage.employeeName = callDetails.receptionistMessage.employeeName;
                receptionistMessage.formName = callDetails.receptionistMessage.formName;
                receptionistMessage.formResponses = [];
                receptionistMessage.isJunk = callDetails.receptionistMessage.isJunk;
                receptionistMessage.junkStatus = callDetails.receptionistMessage.junkStatus;
                receptionistMessage.canSeeFormResponses = callDetails.receptionistMessage.canSeeFormResponses;
                receptionistMessage.subscriberIds(callDetails.receptionistMessage.subscriberIds);
                let smsRecipients = callDetails.receptionistMessage.smsRecipients || [];
                let recipients = callDetails.receptionistMessage.recipients || [];
                let formattedSmsRecipients = smsRecipients.map((smsRecipient) => {
                    return _phoneNumberFormatter.toInternationalWithParens(smsRecipient);
                });
                receptionistMessage.recipients = recipients.concat(formattedSmsRecipients).sort() || [];
            }

            const callDetailsPresentationObject = new CallDetailsPresentationObject();
            callDetailsPresentationObject.callId = callHistoryId;
            callDetailsPresentationObject.firstCallDetailStep = firstCallDetailStep;
            callDetailsPresentationObject.callDetailSteps = callDetailSteps;
            callDetailsPresentationObject.callerLocation = callerLocation;
            callDetailsPresentationObject.calleeLocation = calleeLocation;
            callDetailsPresentationObject.voicemail = voicemail;
            callDetailsPresentationObject.recording = recording;
            callDetailsPresentationObject.receptionistMessage = receptionistMessage;
            callDetailsPresentationObject.mapUrl = callDetails.mapUrl;

            return callDetailsPresentationObject;
        };

        self.formatCallDetailsForDisplay = (callHistoryId, callDetails) => {
            return _formatCallDetailsForDisplay(callHistoryId, callDetails);
        };

        self.init = () => {


        };
    };
});

